import { CommonModule } from '@angular/common';
import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  Inject,
  OnInit,
} from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatGridListModule } from '@angular/material/grid-list';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { Router, RouterModule } from '@angular/router';
import {
  AuthService,
  PictureService,
  StorageService,
} from '@pulpo/pulpo-api';
import {
  CompanyInfos,
  IPiwigoImage,
  PictureTypeEnum,
  User,
  UserRightEnum,
} from '@pulpo/pulpo-models';
import {
  HasPermissionsDirective,
  HideForEnvsDirective,
} from '../../directives';
import { APP_CONFIG } from '@pulpo/app-config';

@Component({
  selector: 'navbar',
  templateUrl: './navbar.component.html',
  styleUrls: ['navbar.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [
    CommonModule,
    MatGridListModule,
    MatIconModule,
    MatButtonModule,
    MatMenuModule,
    HasPermissionsDirective,
    HideForEnvsDirective,
    RouterModule,
  ],
})
export class NavbarComponent implements OnInit {
  UserRightEnum = UserRightEnum;
  isNavbarCollapsed: boolean;
  languages: any[];
  version: string;
  currentUser: User | undefined;
  logo: IPiwigoImage;
  isCompanyMember = false;
  accountImage: any;
  ribbonEnv: string;
  environment: any;
  companyInfos: CompanyInfos;
  constructor(
    @Inject(APP_CONFIG) environment: any,
    private pictureService: PictureService,
    private cdr: ChangeDetectorRef,
    private router: Router,
    private authService: AuthService,
    private storageService: StorageService
  ) {
    this.isNavbarCollapsed = true;
    this.environment = environment;
  }

  ngOnInit() {
    if (
      this.authService.isLoggedIn() &&
      (this.currentUser === null || this.currentUser === undefined)
    ) {
      this.setupRibbon();
      this.logged();
    }
    this.authService.onLogged$.subscribe(() => {
      console.log('authService.onLogged$');
      this.setupRibbon();
      this.logged();
      this.cdr.markForCheck();
    });
  }

  setupRibbon() {
    this.ribbonEnv = this.resolveRibbonLabel();
    this.cdr.markForCheck();
  }

  private resolveRibbonLabel(): string {
    if (this.environment?.ribbonLabel) {
      return this.environment.ribbonLabel;
    }

    const normalizedName = (this.environment?.name || '').toLowerCase();
    if (normalizedName.includes('local')) {
      return 'local';
    }
    if (normalizedName.includes('dev')) {
      return 'development';
    }
    if (normalizedName.includes('staging')) {
      return 'staging';
    }
    return '';
  }
  logged() {
    this.currentUser = this.storageService.getUser();
    this.companyInfos = this.storageService.getCompanyInfos()!;

    if (this.currentUser) {
      this.pictureService
        .getPicturesByTypeAndId(PictureTypeEnum.USER, this.currentUser.id)
        .subscribe((res: any) => {
          if (res.body) {
            this.accountImage = res.body[0];
            this.cdr.markForCheck();
          }
        });
    }
  }

  collapseNavbar() {
    this.isNavbarCollapsed = true;
  }

  login() {
    this.router.navigate(['/login']);
  }

  logout() {
    this.authService.logout();
    this.currentUser = undefined;
    this.router.navigate(['/login']);
    this.cdr.detectChanges();
  }

  toggleNavbar() {
    this.isNavbarCollapsed = !this.isNavbarCollapsed;
  }
}
